<template>
<v-card flat >
  <v-card-title class='subtitle-1 overline' >
  </v-card-title>
  <v-card-text
    class='text-center'
    style='max-width:380px;margin-left:auto;margin-right:auto;' >

    <v-btn block rounded x-large outline
      v-for='action in actions'
      v-on="action.events"
      v-bind='action.attrs'
      :key='action.id'
      @click='action.click'
      color='primary'
      style='border-radius:25px;'
      class='mb-4' >
      {{ action.text }}
      <v-icon class='ml-2' small v-if='action.icon' >{{action.icon}}</v-icon>
    </v-btn>

    <v-btn block rounded x-large outlined
      v-if='withDone'
      color='primary'
      class='my-4'
      @click='$emit("close")' >
      Done
    </v-btn>

  </v-card-text>
  <!-- <pre v-text="value" /> -->
</v-card>
</template>
<script>
export default {
  name: 'SuccessScreen',
  props: {
    value: { type: Object },
    actions: { type: Array, default: () => { return [] } },
    withDone: { type: Boolean, default: true }
  }
}
</script>



// WEBPACK FOOTER //
// SuccessScreen.vue?7990a5cd